import NotificationService from "./NotificationService";

export const handlePushNotificationChange = async (
  enabled: boolean
): Promise<boolean> => {
  try {
    if (enabled) {
      const permission = await NotificationService.requestPermission();

      if (permission === "granted") {
        const registration = await NotificationService.registerServiceWorker();

        if (registration) {
          const subscription = await NotificationService.subscribeUserToPush();
          return !!subscription;
        } else {
          return false;
        }
      } else {
        return false;
      }
    } else {
      return NotificationService.unsubscribeFromPush();
    }
  } catch {
    return false;
  }
};
